let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("2KbAD")).then(() => parcelRequire('bfgbA'));